import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AdminShell from "../components/AdminShell";
import AppPage from "../components/AppPage";
import { WorkspaceToolbar, WorkspaceTableScroll } from "../components/WorkspacePanel";
import { adminEventsApi } from "../api";

const EVENT_RU = {
  page_view: "Просмотр",
  calc_use: "Калькулятор",
  cta_click: "Клик CTA",
  register_done: "Регистрация",
  company_created: "Компания",
  login: "Вход",
};

const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("ru-RU", { dateStyle: "short", timeStyle: "short" });
  } catch {
    return iso;
  }
};

export default function AdminAnalytics() {
  const { t } = useTranslation();
  const [days, setDays] = useState(7);
  const [eventFilter, setEventFilter] = useState("all");
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [err, setErr] = useState("");

  const load = async () => {
    setErr("");
    try {
      const data = await adminEventsApi({ days, event: eventFilter, limit: 200 });
      setRows(data.items || []);
      setTotal(data.total || 0);
    } catch (e) {
      setErr(e?.response?.data?.detail || t("admin.load_error"));
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [days, eventFilter]);

  return (
    <AdminShell title={t("admin.nav.analytics")}>
      <AppPage bodyScroll="table" toolbar={(
        <WorkspaceToolbar>
        <div className="d-flex flex-wrap gap-2 mb-3 align-items-center">
          <div className="btn-group btn-group-sm">
            {[1, 7, 30].map((d) => (
              <button
                key={d}
                type="button"
                className={`btn ${days === d ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setDays(d)}
              >
                {d} {t("admin.days")}
              </button>
            ))}
          </div>
          <select
            className="form-select form-select-sm"
            style={{ width: 180 }}
            value={eventFilter}
            onChange={(e) => setEventFilter(e.target.value)}
          >
            <option value="all">{t("common.all")}</option>
            {Object.entries(EVENT_RU).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
          <span className="small text-muted ms-auto">{total} {t("admin.events_total")}</span>
        </div>

        {err && <div className="alert alert-danger">{err}</div>}
        </WorkspaceToolbar>
      )}>
      <WorkspaceTableScroll className="card border-0 shadow-sm">
        <table className="table table-sm table-hover mb-0 align-middle">
          <thead className="table-light" style={{ position: "sticky", top: 0, zIndex: 2 }}>
            <tr>
              <th>{t("admin.col.time")}</th>
              <th>{t("admin.col.ip")}</th>
              <th>{t("admin.col.event")}</th>
              <th>{t("admin.col.path")}</th>
              <th>UTM</th>
              <th>{t("admin.col.label")}</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center text-muted py-4">{t("admin.no_data")}</td>
              </tr>
            ) : rows.map((r, i) => (
              <tr key={`${r.ts}-${i}`}>
                <td className="text-nowrap small">{fmtDate(r.ts)}</td>
                <td className="small font-monospace">{r.ip_display || "—"}</td>
                <td>
                  <span className="badge bg-light text-dark border">
                    {EVENT_RU[r.event] || r.event}
                  </span>
                </td>
                <td className="small"><code>{(r.path || "/").slice(0, 60)}</code></td>
                <td className="small text-muted">
                  {[r.utm_source, r.utm_campaign].filter(Boolean).join(" / ") || "—"}
                </td>
                <td className="small">{r.label || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </WorkspaceTableScroll>
      </AppPage>
    </AdminShell>
  );
}
